import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextArticleTextbox, {
  ArticleTextboxContextType,
} from '@contexts/articleTextbox'
import { mobileCSS } from '@measures/responsive'

const { ArticleTextboxContext } = contextArticleTextbox

type StyledWrapperProps = Pick<ArticleTextboxContextType, 'isPromo'>

const StyledWrapper = styled.div<StyledWrapperProps>`
  ${({
    theme: {
      measures: {
        content: { defaultMargin },
      },
    },
    isPromo,
  }) => {
    return css`
      margin: ${defaultMargin} ${isPromo ? '0' : '24px'};

      ${mobileCSS(css`
        margin: ${defaultMargin} 0px;
      `)}
    `
  }}
`

const Wrapper: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  const { isPromo } = useContext(ArticleTextboxContext)
  return <StyledWrapper isPromo={isPromo}>{children}</StyledWrapper>
}

export default Wrapper
